module.exports = __webpack_public_path__ + "media/images/country_flags/pa-72102d9ace43a68408e3c402ff0754cc.png";